export interface ObscurlOutcome {
	request: ObscurlRequest
	nonce: string
}

interface ObscurlRequest {
	service: Service,
	data: any
}

export enum Service {
	CD_UPLOAD = 'cd_upload',
	DICOMIZE = 'dicomize'
}
